// ** Initial State
const initialState = {
  stripeLink: null,
}

const bankReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_STRIPE_LINK":
      return {
        ...state,
        stripeLink: action.payload,
      }
    default:
      return state
  }
}

export default bankReducer
